import { DragDropContext, Draggable } from "react-beautiful-dnd";
import { DroppableContainer } from "../../components/admin/DndTemplate/helper/DndHelper";
import { consultationJSONAtom } from "../../new_consultation/constants/_constant";
// import { useItemsFilter } from "../../_helper/actions/app/items";
// import { ApiEndPoint } from "../../_helper/constant/api-types";
// import { clinicAtom } from "../../_helper/constant/constant-atom";
// import { useEffect } from "react";
import { useAtom } from "jotai";

const ConsultationOrdering = () => {
  // const [clinic] = useAtom(clinicAtom);
  const [consultationJSON, setConsultationJSON] = useAtom(consultationJSONAtom);

  // const { data: tagTypes, isLoading: customfieldsLoading } = useItemsFilter(
  //   ApiEndPoint.QP_CM_TAG_TYPES,
  //   `?action=getTagTypes&clinic_id=${clinic?.id}&backend=True`,
  //   clinic?.id ? true : false
  // );

  // function removeDuplicates(array, property) {
  //   return array.filter(
  //     (obj, index, self) =>
  //       index === self.findIndex((o) => o[property] === obj[property])
  //   );
  // }

  // useEffect(() => {
  //   if (tagTypes) {
  //     const customfields = tagTypes?.map((tag, i) => {
  //       return {
  //         id: consultationJSON?.length + (i + 1),
  //         label: tag?.name,
  //         offset: "TAGS",
  //         key: "customField",
  //         tagId: tag?.id,
  //       };
  //     });

  //     setConsultationJSON((prev) =>
  //       removeDuplicates([...prev, ...customfields], "label")
  //     );
  //   }
  // }, [tagTypes]);

  // const dragEndHandler = (result) => {
  //   const { destination, source } = result;
  //   if (destination) {
  //     if (destination?.droppableId === "consultation-fields") {
  //       setConsultationJSON((prev) => {
  //         const prevSeq = [...prev];
  //         const temp = prevSeq[destination?.index];
  //         prevSeq[destination?.index] = prevSeq[source?.index];
  //         prevSeq[source?.index] = temp;
  //         return prevSeq;
  //       });
  //     }
  //   } else {
  //     //("invalid drop");
  //   }
  // };
  const dragEndHandler = (result) => {
    const { destination, source } = result;

    // Check if there is a valid drop destination
    if (!destination) return;

    setConsultationJSON((prev) => {
      const prevSeq = [...prev];

      // Remove the dragged item from its original position
      const [movedItem] = prevSeq.splice(source.index, 1);

      // Insert the dragged item at the new position
      prevSeq.splice(destination.index, 0, movedItem);

      return prevSeq;
    });
  };

  return (
    <DragDropContext onDragEnd={dragEndHandler}>
      <DroppableContainer
        droppableId={`consultation-fields`}
        style={{}}
        className=""
      >
        <div className="prescription-setup-sequence">
          {consultationJSON?.map((data, i) => (
            <Draggable draggableId={`${data?.label}${i}`} index={i} key={i}>
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  style={{
                    ...provided.draggableProps.style,
                  }}
                  className="border rounded-[5px] px-4 text-base font-normal w-[245px]"
                >
                  {`${i + 1}. ${data?.label}`}
                </div>
              )}
            </Draggable>
          ))}
        </div>
      </DroppableContainer>
    </DragDropContext>
  );
};

export default ConsultationOrdering;
